// src/jsx/app.jsx
import {
	Routes,
	Route,
	NavLink,
	Navigate,
	useNavigate,
	useLocation,
	useRouteMatch
  } from 'react-router-dom';
import React, { useEffect,useState } from 'react';

import Footer from './views/components/payg/commonModules/footer.jsx';
import SuperAdminMainContent from './views/components/payg/superAdmin/maincontentsuperadminpayg.jsx';
// import Header from '../views/components/payg/commonModules/header.jsx';


import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {getAccess} from './jsx/actions/accessAction'
import { TranslateProvider } from 'translate-components'
import translations from './translations.json'
import 'moment/locale/fr'
import Header from './views/components/payg/commonModules/layouts/Header.jsx';
import {messaging} from './firebase';
import { Box } from '@material-ui/core';

// Initialised model with meta data
var element = document.querySelector('meta[name-user="username"]');
var content = element && element.getAttribute("content");
var UserName = content;

var elementToken = document.querySelector('meta[token-user="tokenUser"]');
var contentToken = elementToken && elementToken.getAttribute("content");
var TokenUser = contentToken;

 function SuperAdminMainViewI(props) {
	const navigate = useNavigate();
	const location = useLocation();

	const [inLeftSideBar, setinLeftSideBar] = useState("none");
	const [mainContent, setmainContent] = useState("Accueil");
	const [mainContentProps, setmainContentProps] = useState(null);
	const [isInit, setIsInit] = useState(false);

	useEffect(() => {
		if (!isInit){
			try{
				Notification.requestPermission();
				messaging.getToken({vapidKey: 'BBjo5I9JqKdsmvue-ND-GKB-9c13MD_6BWMiOioGh2QjuAL2M1ilQDyRTZlIp3qxZ7gj7d3kA9k-kW3vETjju1U'}).then((currentToken) => {
					if (currentToken) {
					  console.log('current token for client: ', currentToken);
					  // Track the token -> client mapping, by sending to backend server
					  // show on the UI that permission is secured
					  sendTokenServer(currentToken)
					} else {
					  console.log('No registration token available. Request permission to generate one.');
					  // shows on the UI that permission is required 
					}
				  }).catch((err) => {
					console.log('An error occurred while retrieving token. ', err);
					// catch error while creating client token
				  });
		
				}catch{
					
				}
				console.log('[DEBUG], MainView, indexAdmin,componentDidMount ',props);					
				props.getAccess(props.pageRaw)	
				setIsInit(true)
		}
		
	  });
	
	const sendTokenServer = async (currentToken) =>{
		const response = await fetch('/notification/fccm/key',{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				//'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
			},
			body: JSON.stringify({
				expoPushToken: currentToken,
			}),
			credentials: 'same-origin',
		})
		const resp2 = await response.json()
		console.log({resp2});
	}
	

	const handleUserInput = ( inLeftSideBar) => {
		if (inLeftSideBar === 'UserProfile'){
			setinLeftSideBar("none")
			setmainContent(inLeftSideBar)
		} else {
			setmainContent(inLeftSideBar)
		}
	}
	const  handleSelectMenu = (selectedMenu, propslocal = null) => {
		console.log("MAJOR MENU -----", selectedMenu, " page ",props.page);
		if(!props.page.includes(selectedMenu) && selectedMenu !== "Accueil"){
			selectedMenu = "Accueil"
		}
		setinLeftSideBar("none")
		setmainContent(selectedMenu)
		setmainContentProps(propslocal)

		console.log("ORIGIN >> +",selectedMenu)
		switch (selectedMenu) {
			case "Money":
				navigate('userrepayment')
				break;
			case "Dashboard":	
				navigate('paygomap')
				break;	
			case "Detail":
				navigate('userdetails')
				break;
			case "Sms":
				navigate('smsmanagement')
				break;
			case "Financial":
				navigate('financial')
				break;	
			case "Paiement":
				navigate('userprofile')
				break;
			case "Management Issue":
				navigate('boxmanagement')
				break;
			case "Config":
				navigate('suppress')
				break;
            case "Account":
				navigate('account')
				break;
			case "Box":
				navigate('userdetails')
				break;
			case "Enter Code":
				navigate('entercode')
				break;
			case "Production":
				navigate('production')
				break;
			case "Consommation":
				navigate('consumption')
				break;	
			default:
				break;
		}
	}
	const RemoveMenus = () => {
		setinLeftSideBar("none")
	}

	return(
			<>
				<TranslateProvider debugMode={true} translations={translations} defaultLanguage={props.language}>
				<Box>
					<Header
						barStatus={inLeftSideBar}
						handleUserProfile={handleUserInput}
						userName = " bring energy anywhere"
						ClickOnMenu={handleSelectMenu}
						SelectedMenu={mainContent}
						{...props}
					/>
						<section id="main" className={ mainContent === "Dashboard" && "bgm-dashboard"}>
						 <SuperAdminMainContent
								mainContent= {mainContent}
								tokenUser = {TokenUser}
								ClickOnMenu={handleSelectMenu}
								mainContentProps={mainContentProps}
								RemoveMenus={RemoveMenus}
							/> 
						</section>
					<Footer/>
				</Box>
				</TranslateProvider>
			</>
		)
}

const mapStateToProps = (state) => {
return {
	language: state.language,
	page : state.userAccess.PAGES,
	pageRaw : state.auth.pageRaw,
	// pageRaw : state.auth.user.tokenAcess,
	token : state.auth.token,
}
}
function mapDispatchToProps(dispatch){
return bindActionCreators({
	
	getAccess: getAccess,
}, dispatch)
}


const App = connect(mapStateToProps, mapDispatchToProps)(SuperAdminMainViewI)

export default App;



